// TODO: @joao-tonial This is duplicated. Create a shared ErrorBoundary
import { Component, ErrorInfo, ReactElement, ReactNode, useCallback } from 'react';
import { ActionType, ComponentType } from '@cbhq/client-analytics';

import { useAnalytics } from '../hooks/useAnalytics';

import { AppSwitcherButton } from './AppSwitcherButton';

type InnerErrorBoundaryProps = {
  children: ReactNode;
  onReloadPress?: () => void;
  onBoundaryError?: (error: Error, errorInfo: ErrorInfo) => void;
};
type InnerErrorBoundaryState = { hasError: boolean };

export class InnerErrorBoundary extends Component<
  InnerErrorBoundaryProps,
  InnerErrorBoundaryState
> {
  constructor(props: InnerErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.props.onBoundaryError?.(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <AppSwitcherButton />;
    }

    return this.props.children;
  }
}

type ErrorBoundaryProps = { children: ReactElement };

export function ErrorBoundary(props: ErrorBoundaryProps) {
  const { logEvent } = useAnalytics();
  const handleError = useCallback(
    (error: Error, errorInfo: ErrorInfo) => {
      logEvent('app_switcher_error_boundary_error', {
        action: ActionType.view,
        componentType: ComponentType.page,
        error: error.message ?? 'unknown error',
        errorInfo: errorInfo.componentStack ?? 'unknown error info',
      });
    },
    [logEvent],
  );

  return <InnerErrorBoundary onBoundaryError={handleError} {...props} />;
}
